import React from "react";

import { LayoutType } from "@formant/core/model/LayoutType";
import { Icon, IconName } from "@formant/ui/component/common/Icon";

export const F3TabIcon = ({ icon }: { icon?: string }) => {
    return <Icon name={getIconName(icon)} size="18" />;
};

export function getIconName(icon: string | undefined): IconName {
    switch (icon) {
        case "plus":
            return "plus";
        case "joystick":
            return "joystick";
        case "infinity":
            return "stream";
        case "board":
            return "dashboard";
        case "analytics":
            return "numeric";
        case "view":
            return "dashboard";
        case "bell":
            return "bell";
        case "calendar":
            return "calendar";
        default:
            return "dashboard";
    }
}

export const getIconFromLayoutType = (type: LayoutType): string => {
    switch (type) {
        case "analytics":
            return "analytics";
        case "teleop":
            return "joystick";
        default:
            return "view";
    }
};
